import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const GreenCheckMarkIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="50" height="50" viewBox="0 0 512 512">
		<g transform="translate(0 0.39)">
			<circle cx="256" cy="256" r="256" transform="translate(0 -0.39)" fill="#2cbf50" opacity="0.15" />
			<path
				d="M228.962,43.455,104.519,167.9a20.2,20.2,0,0,1-28.591,0L13.707,105.677A20.207,20.207,0,0,1,42.271,77.086l47.966,47.939L200.371,14.863a20.217,20.217,0,1,1,28.591,28.592Z"
				transform="translate(134.666 164.226)"
				fill="#1c7c51"
				fillRule="evenodd"
			/>
		</g>
	</svg>
);
